/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/TextPattern.yaml

import { ScanbotTextPatternImpl } from './impl';
import type { ResultWrapper } from './types/base/customTypes';
import type { TextPatternScannerScreenConfiguration } from './types/core/ui_v2/text_pattern/TextPatternScannerScreenConfiguration';
import type { TextPatternScannerUiResult } from './types/core/ui_v2/text_pattern/TextPatternScannerUiResult';

/**
 * Entry point for all Text Pattern scanning features.
 */
export const ScanbotTextPattern = {
  /**
   * Opens the Ready-To-Use UI Text Pattern scanner with the desired configuration.
   * @param {TextPatternScannerScreenConfiguration} configuration - The Text Pattern scanner configuration to be used for scanning.
   * @returns {Promise<ResultWrapper<TextPatternScannerUiResult>>} - The result of the Text Pattern scanning operation.
   */
  async startScanner(
    configuration: TextPatternScannerScreenConfiguration,
  ): Promise<ResultWrapper<TextPatternScannerUiResult>> {
    return ScanbotTextPatternImpl.startScanner(configuration);
  },
  /**
   * Forces the Ready-To-Use UI Text Pattern scanner to close if it is currently open.
   * @returns {Promise<void>}
   */
  async forceCloseScanner(): Promise<void> {
    return ScanbotTextPatternImpl.forceCloseScanner();
  },
};
